export default "__VITE_ASSET__DJbUf5D___"